import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import classnames from 'classnames';
import ddt from '@wix/da-ddt';
import { getInfoToDisplayImageDeviation } from './_helpers';
import Unknown from '../Unknown';
import Flag from '@wix/da-react-context/pkg/flags/Flag';
import { useLazyLoading } from '../../../LazyLoadingImage/useLazyLoading';
import { isValidFileSrc } from '../../_helpers';
import s from './Image.scss';
/**
 * If you are changing any fundamentals here please remember to also
 * consider the DaEditorWrappers image views, they use this to generate
 * HTML and react version of editor text.
 */ const ImageDumbView = (props)=>{
    const { deviation, className, width: propsWidth, height: propsHeight, allowPreviewUsage = true, useBackgroundColor = true, greenLikeCrop, noCropping, extraWrapStyles, 'aria-hidden': ariaHidden } = props;
    const { ref, inView, enableLazyLoading, supportsNativeLazy } = useLazyLoading(true);
    if (!propsWidth && !propsHeight) {
        // no use-cases for responsive image views
        ddt.warn('deviationviews', 'Deviation image is not rendered because of missing Width and Height properties');
        return null;
    }
    const info = getInfoToDisplayImageDeviation({
        deviation,
        height: propsHeight,
        width: propsWidth,
        allowPreviewUsage,
        greenLikeCrop,
        noCropping
    });
    if (!info || !info.pickedImage || !isValidFileSrc(info.pickedImage.src)) {
        ddt.warn('deviationviews', 'Could not find a suitable image file to render deviation image', info);
        return /*#__PURE__*/ React.createElement(Unknown, props);
    }
    const { height, width, imgStyles, pickedImage } = info;
    ddt.log('deviationviews.thumbtype', `Used ${pickedImage.type}`);
    const imageProps = {
        src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
    };
    const wrapStyles = _object_spread_props(_object_spread({}, extraWrapStyles), {
        width,
        height
    });
    const imageStyles = _object_spread({
        width,
        height
    }, imgStyles);
    // Native lazy loading is simple
    if (enableLazyLoading && supportsNativeLazy) {
        imageProps.loading = 'lazy';
        imageProps.src = pickedImage.src;
    }
    // Intersection Observer lazy loading
    if (enableLazyLoading && !supportsNativeLazy) {
        if (inView) {
            imageProps.src = pickedImage.src;
        }
    }
    // Standard non lazy loaded
    if (!enableLazyLoading) {
        imageProps.src = pickedImage.src;
    }
    if (pickedImage.srcSet) {
        imageProps.srcSet = pickedImage.srcSet;
    }
    return /*#__PURE__*/ React.createElement("div", {
        ref: enableLazyLoading && !supportsNativeLazy ? ref : undefined,
        className: classnames(s['wrapper'], className, !useBackgroundColor && s['no-background']),
        style: wrapStyles,
        "aria-hidden": ariaHidden
    }, renderDebug(info.pickedImage, propsWidth, propsHeight, enableLazyLoading), /*#__PURE__*/ React.createElement("img", _object_spread({
        alt: deviation.title,
        style: imageStyles
    }, imageProps)), enableLazyLoading && !supportsNativeLazy && /*#__PURE__*/ React.createElement("noscript", null, /*#__PURE__*/ React.createElement("img", {
        alt: deviation.title,
        src: pickedImage.src,
        srcSet: pickedImage.srcSet,
        style: imageStyles
    })));
};
ImageDumbView.displayName = 'ImageDumbView';
function renderDebug(pickedImage, propsWidth, propsHeight, isLazy) {
    return /*#__PURE__*/ React.createElement(Flag, {
        condition: "thumbdebug"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['thumb-debug']
    }, isLazy && 'lazy/', pickedImage.type, "/", pickedImage.src.replace(/\?.*/, '').split('.').pop(), "/", pickedImage.transparency === true ? 'true' : 'false', "/", /*#__PURE__*/ React.createElement("abbr", {
        title: "imageDims"
    }, pickedImage.width, "x", pickedImage.height), "/", /*#__PURE__*/ React.createElement("abbr", {
        title: "blockDims"
    }, propsWidth, "x", propsHeight)));
}
export default ImageDumbView;
